export default __webpack_public_path__ + "static/media/2020 Annual Corporate Governance Report (SCORE CARD).01abbb74.pdf";